import type { Lead } from './api';

/**
 * A ordem da coluna e a ordem de atender: primeiro quem espera resposta, e
 * dentro de cada grupo quem esta parado ha mais tempo. Sem isso o quadro
 * mostrava o ultimo que chegou no topo - justamente o que menos urge.
 */
export function ordenarLeads(leads: Lead[]): Lead[] {
  return [...leads].sort(
    (a, b) =>
      Number(b.waitingReply) - Number(a.waitingReply) ||
      new Date(a.enteredStageAt).getTime() - new Date(b.enteredStageAt).getTime(),
  );
}
